import React from 'react';
import { Hero } from './components/Hero';
import { WhatIncludes } from './components/WhatIncludes';
import { PainValidation } from './components/PainValidation';
import { Solution } from './components/Solution';
import { HowItWorks } from './components/HowItWorks';
import { Features } from './components/Features';
import { Benefits } from './components/Benefits';
import { Bonuses } from './components/Bonuses';
import { Pricing } from './components/Pricing';
import { WhyPackCompleto } from './components/WhyPackCompleto';
import { FinalCTA } from './components/FinalCTA';
import { SocialProofPopup } from './components/SocialProofPopup';
import { UrgencyBanner } from './components/UrgencyBanner';
import { Testimonials } from './components/Testimonials';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="min-h-screen bg-[#fafaf9] font-sans text-stone-900" data-id="element-0">
      <UrgencyBanner data-id="element-1" />
      <Hero data-id="element-2" />
      <WhatIncludes data-id="element-3" />
      <PainValidation data-id="element-4" />
      <Solution data-id="element-5" />
      <HowItWorks data-id="element-6" />
      <Features data-id="element-7" />
      <Benefits data-id="element-8" />
      <Bonuses data-id="element-9" />
      <Pricing data-id="element-10" />
      <WhyPackCompleto data-id="element-11" />
      <Testimonials data-id="element-12" />
      <FinalCTA data-id="element-13" />
      <SocialProofPopup data-id="element-14" />
      <WhatsAppButton data-id="element-15" />
    </div>;
}